var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// @ts-ignore
var __ = wp.i18n.__;
import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
var COMMON_GALLERY_PROPERTIES = {
    closeTitle: 'Fermer',
    zoomTitle: 'Zoomer',
    arrowPrevTitle: 'Précédente',
    arrowNextTitle: 'Suivante',
    errorMsg: 'Cette image n\'a pas pu être chargée',
    pswpModule: PhotoSwipe,
    bgOpacity: 1,
    padding: { top: 16, right: 16, left: 16, bottom: 16 }
};
var BREAKPOINTS = Object.freeze({
    mobile: 480,
    small: 600,
    medium: 782,
    large: 960,
    xlarge: 1080,
    wide: 1280,
    huge: 1440,
});
var AtelierRmp = /** @class */ (function () {
    function AtelierRmp() {
        /**
         * Heading information
         * @private
         */
        this.heading = {};
        /**
         * Logo urls
         * @private
         */
        this.logo = { isInitial: true };
        this.resizeObservers = [];
        this.switchActivationObservers = [];
        this.switchObservers = [];
        this.header = { height: 0, switchEnabled: false, isSwitched: false };
        this.watchHeadingForHeaderSwitch = this.watchHeadingForHeaderSwitch.bind(this);
        this.resize = this.resize.bind(this);
        this.restoreLogoOnSwitchActivationChange = this.restoreLogoOnSwitchActivationChange.bind(this);
        /*
         * Enable switch detection
         */
        this.detectHeaderSwitchActivation = this.detectHeaderSwitchActivation.bind(this);
        this.resizeObservers.push(this.detectHeaderSwitchActivation);
        this.detectHeaderSwitchActivation();
        /**
         * Initialize elements
         */
        this.initHeader();
        this.initZoneOpeners();
        this.initHeading();
        this.initSliders();
        this.initImageSlider();
        this.initWorks();
        /**
         * Run Switch
         */
        this.switch(this.headerMustSwitch());
        /**
         * Watch resize
         */
        window.addEventListener('resize', this.resize);
    }
    AtelierRmp.prototype.resize = function () {
        this.resizeObservers.forEach(function (callback) { return callback(); });
    };
    /**
     * Get logo urls
     * @private
     */
    AtelierRmp.prototype.initHeader = function () {
        var _this = this;
        this.header.element = document.querySelector('.branding-header');
        if (!this.header.element) {
            return;
        }
        // Change header value on window resize
        this.resizeObservers.push(function () {
            var height = _this.header.element.getBoundingClientRect().height;
            if (_this.header.height !== height) {
                _this.setHeaderHeight(height);
            }
        });
        this.setHeaderHeight(this.header.element.getBoundingClientRect().height);
        // Get Logo urls
        var logo = this.header.element.querySelector('img.logo');
        if (logo) {
            this.logo = {
                element: logo,
                src: logo.src,
                isInitial: true,
            };
            if (logo.dataset.variationWhite) {
                if (this.isValidUrl(logo.dataset.variationWhite)) {
                    this.logo.white = logo.dataset.variationWhite;
                }
            }
            if (logo.dataset.variationBlack) {
                if (this.isValidUrl(logo.dataset.variationBlack)) {
                    this.logo.black = logo.dataset.variationBlack;
                }
            }
            this.switchActivationObservers.push(this.restoreLogoOnSwitchActivationChange);
        }
    };
    AtelierRmp.prototype.initZoneOpeners = function () {
        document.querySelectorAll('.zone-opener').forEach(function (button) {
            var targetName = button.getAttribute('aria-controls');
            if (!targetName) {
                return;
            }
            var target = document.getElementById(targetName);
            if (!target) {
                return;
            }
            button.addEventListener('click', function () {
                var isOpen = button.ariaExpanded === 'true';
                var classes = "open-zone-".concat(targetName);
                if (isOpen) {
                    document.body.classList.remove('zone-open', classes);
                    target.classList.remove('is-open');
                    button.classList.remove('open');
                    button.ariaExpanded = 'false';
                }
                else {
                    document.body.classList.add('zone-open', classes);
                    target.classList.add('is-open');
                    button.classList.add('open');
                    button.ariaExpanded = 'true';
                }
            });
        });
    };
    AtelierRmp.prototype.initHeading = function () {
        var _this = this;
        if (document.body.classList.contains('heading-white')) {
            this.heading.color = 'white';
        }
        else if (document.body.classList.contains('heading-black')) {
            this.heading.color = 'black';
        }
        this.heading.element = document.querySelector('.heading');
        if (this.heading.element) {
            new IntersectionObserver(function (_a) {
                var e = _a[0];
                if (e.isIntersecting) {
                    window.addEventListener('scroll', _this.watchHeadingForHeaderSwitch);
                }
                else {
                    window.removeEventListener('scroll', _this.watchHeadingForHeaderSwitch);
                }
            }, { threshold: [0] }).observe(this.heading.element);
        }
    };
    /**
     * Create sliders
     * @private
     */
    AtelierRmp.prototype.initSliders = function () {
        document.querySelectorAll('.section-team  .swiper').forEach(function (container) {
            var _a;
            var options = {
                speed: 750,
                loop: true,
                slidesPerView: 1,
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: (_a = {},
                    _a[BREAKPOINTS.medium] = {
                        slidesPerView: 2,
                    },
                    _a[BREAKPOINTS.large] = {
                        slidesPerView: 3,
                    },
                    _a),
            };
            // @ts-ignore
            var swiper = new Swiper(container, options);
        });
        return;
        var sliders = [];
        var defaultOptions = {
            navPosition: 'bottom',
            slideBy: "page",
            autoplay: true,
            autoplayHoverPause: true,
            autoplayButtonOutput: false,
            speed: 750,
            controlsText: [
                '<span class="screen-reader-text">' + __('Précédent', 'atelier-rmp') + '</span>',
                '<span class="screen-reader-text">' + __('Suivant', 'atelier-rmp') + '</span>',
            ]
        };
        document.querySelectorAll('.section-team .team-container').forEach(function (container) {
            var _a;
            sliders.push(__assign(__assign({}, defaultOptions), { container: container, controls: false, items: 1, responsive: (_a = {},
                    _a[BREAKPOINTS.medium] = {
                        items: 2
                    },
                    _a[BREAKPOINTS.large] = {
                        items: 3
                    },
                    _a) }));
        });
        // @ts-ignore
        sliders.forEach(function (options) { return tns(options); });
    };
    AtelierRmp.prototype.initImageSlider = function () {
        var _a;
        var options = {
            autoplay: true,
            speed: 750,
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enabled: false
            },
            breakpoints: (_a = {},
                _a[BREAKPOINTS.medium] = {
                    navigation: {
                        enabled: true
                    }
                },
                _a[BREAKPOINTS.large] = {
                    slidesPerView: 3,
                },
                _a),
        };
        document.querySelectorAll('.section-gallery > .images-container').forEach(function (container) {
            var element = container.querySelector('.swiper');
            if (!element) {
                return;
            }
            // @ts-ignore
            var swiper = new Swiper(element, options);
            /** @type { HTMLElement | null } previousButton  **/
            var previousButton = container.querySelector('.swiper-button-prev');
            /** @type { HTMLElement | null } previousButton  **/
            var nextButton = container.querySelector('.swiper-button-next');
            if (previousButton) {
                previousButton.setAttribute('aria-controls', swiper.wrapperEl.getAttribute('id'));
                previousButton.addEventListener('click', function () {
                    swiper.slidePrev();
                });
            }
            if (nextButton) {
                nextButton.setAttribute('aria-controls', swiper.wrapperEl.getAttribute('id'));
                nextButton.addEventListener('click', function () { return swiper.slideNext(); });
            }
        });
    };
    AtelierRmp.prototype.initWorks = function () {
        var items = [];
        document.querySelectorAll('.section-works .work.has-gallery').forEach(function (container) {
            var template = container.querySelector('template.work-gallery-items');
            if (!template) {
                return;
            }
            var fragment = document.importNode(template.content, true);
            var images = fragment.querySelectorAll('img');
            if (!images.length) {
                return;
            }
            items = __spreadArray(__spreadArray([], items, true), Array.from(images).map(function (img, index) {
                if (index === 0) {
                    return { launcher: container, img: img };
                }
                return { img: img };
            }), true);
        });
        if (items.length === 0) {
            return;
        }
        var sources = [];
        var lightbox = new PhotoSwipeLightbox(__assign(__assign({}, COMMON_GALLERY_PROPERTIES), { dataSource: sources }));
        items.forEach(function (_a, index) {
            var launcher = _a.launcher, img = _a.img;
            sources.push({
                src: img.src,
                width: img.width,
                height: img.height,
                alt: img.alt
            });
            if (launcher) {
                launcher.addEventListener('click', function () { return lightbox.loadAndOpen(index); });
            }
        });
        lightbox.init();
    };
    AtelierRmp.prototype.isValidUrl = function (url) {
        if (typeof url === 'string' && !url.startsWith('http')) {
            url = "http:".concat(url);
        }
        try {
            return Boolean(new URL(url));
        }
        catch (e) {
            return false;
        }
    };
    AtelierRmp.prototype.setHeaderHeight = function (height) {
        this.header.height = height;
        document.body.style.setProperty('--wp--custom--header--height', "".concat(height, "px"));
    };
    AtelierRmp.prototype.headerMustSwitch = function () {
        if (!this.heading.element || !this.header.element) {
            return false;
        }
        return this.heading.element.getBoundingClientRect().bottom <= (this.header.height / 2);
    };
    AtelierRmp.prototype.watchHeadingForHeaderSwitch = function () {
        if (!this.heading.element || !this.header.element) {
            return;
        }
        this.switch(this.headerMustSwitch());
    };
    AtelierRmp.prototype.switch = function (isSwitched) {
        if (this.header.element) {
            this.header.element.classList.toggle('switched', isSwitched);
            this.header.isSwitched = isSwitched;
        }
        this.switchLogo();
    };
    AtelierRmp.prototype.switchLogo = function () {
        if (!this.logo.element || !this.logo.src || !this.header.switchEnabled) {
            return;
        }
        var isInitiaTone = this.headerMustSwitch();
        var url = this.logo.src;
        if (!isInitiaTone && this.heading.color === 'white') {
            url = this.logo.white;
        }
        else if (!isInitiaTone && this.heading.color === 'black') {
            url = this.logo.black;
        }
        if (url) {
            this.logo.isInitial = false;
        }
        if (this.logo.element.src !== url) {
            this.logo.element.src = url;
        }
    };
    AtelierRmp.prototype.restoreLogoOnSwitchActivationChange = function (previous, current) {
        if (!this.logo.element || !this.logo.src) {
            return;
        }
        if (current === false) {
            if (this.logo.element.src !== this.logo.src) {
                this.logo.element.src = this.logo.src;
            }
        }
        else if (!this.logo.isInitial) {
            this.switchLogo();
        }
    };
    AtelierRmp.prototype.detectHeaderSwitchActivation = function () {
        var _this = this;
        var previous = this.header.switchEnabled;
        var enabled = window.matchMedia("(min-width:".concat(BREAKPOINTS.xlarge, "px)")).matches;
        this.header.switchEnabled = enabled;
        if (previous !== enabled) {
            this.switchActivationObservers.forEach(function (observer) { return observer(_this.header.switchEnabled, enabled); });
        }
    };
    return AtelierRmp;
}());
document.addEventListener('DOMContentLoaded', function () {
    new AtelierRmp();
});
